import React from "react";
import { NavLink } from "react-router-dom";

import "./ProfileNavigationItem.css";

const ProfileNavigationItem = (props) => {
	let BaseUrl = window.location.pathname;
	BaseUrl = BaseUrl.split("/");

	if (typeof BaseUrl[3] !== "undefined") {
		BaseUrl = BaseUrl[3].split(" ");
		BaseUrl = BaseUrl[0];
	} else {
		BaseUrl = "public";
	}

	let target = "_self";
	if (props.target) {
		target = props.target;
	}

	let external = false;
	if (props.external) {
		external = true;
	}

	if(external) {
		return (
			<li className="accessible-megamenu-nav-item">
				<a href={props.link} className={'main-nav__primary-nav-item'} target={target}>
					{props.text}
				</a>
			</li>
		);
	} else {
		return (
			<li className="accessible-megamenu-nav-item">
				<NavLink to={props.link} className={(navData) => navData.isActive ? 'main-nav__primary-nav-item active' : 'main-nav__primary-nav-item'} target={target} >
					{props.text}
				</NavLink>
			</li>
		);
	}
}

export default ProfileNavigationItem;
